module.exports = __webpack_public_path__ + "img/tab_icon2.66c13006.png";